import React from 'react';
import Icon from './icons';

// Fixy's icon for each test: the ones on the student Results cards and the Management
// Assessments tab. Use <AssessmentIcon> wherever a test is named so it looks the same everywhere.
export const ASSESSMENT_GLYPHS = {
  riasec: 'compass',
  dass42: 'smile',
  ryff: 'flower',
  sdq: 'puzzle',
};

/** "RIASEC", "DASS-42", "DASS42", "RYFF", "ryff_scale", "SDQ" … → riasec / dass42 / ryff / sdq. */
export const assessmentKey = (type) => {
  const t = String(type || '').toLowerCase();
  if (t.startsWith('riasec')) return 'riasec';
  if (t.startsWith('dass')) return 'dass42';
  if (t.startsWith('ryff')) return 'ryff';
  if (t.startsWith('sdq')) return 'sdq';
  return null;
};

/** The icon for an assessment type; nothing for other types. Takes the same props as <Icon>. */
const AssessmentIcon = ({ type, ...props }) => {
  const glyph = ASSESSMENT_GLYPHS[assessmentKey(type)];
  return glyph ? <Icon name={glyph} {...props} /> : null;
};

export default AssessmentIcon;
